import { render, staticRenderFns } from "./MobileSectionStrip.vue?vue&type=template&id=7971c6bb&scoped=true"
import script from "./MobileSectionStrip.vue?vue&type=script&lang=ts"
export * from "./MobileSectionStrip.vue?vue&type=script&lang=ts"
import style0 from "./MobileSectionStrip.vue?vue&type=style&index=0&id=7971c6bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971c6bb",
  null
  
)

export default component.exports